import { Flex, Typography } from '@aloft/toolkit-sui';

import { selectFullNameWithDefault } from '../../../redux/features/selectors/accountSelectors.ts';
import { selectEffectiveDate, selectOrder } from '../../../redux/features/selectors/orderSelectors.ts';
import { useAppSelector } from '../../../redux/hooks.ts';

export const CertifyModalLicenseDetails = () => {
  const order = useAppSelector((state) => selectOrder(state));
  const appraiserName = useAppSelector((state) => selectFullNameWithDefault(state));
  const effectiveDate = useAppSelector((state) => selectEffectiveDate(state));

  return (
    <Flex
      flexDirection="column"
      padding="15px"
      borderWidth="1px"
      borderRadius="5px"
      borderStyle="solid"
      borderColor="strokeDefault"
      gap="10px"
    >
      <Flex>
        <Typography __dangerDoNotUseSx={{ flex: 1 }} variant="body1" color="textSecondary">
          Appraiser Name
        </Typography>
        <Typography __dangerDoNotUseSx={{ flex: 1 }} variant="body1">
          {appraiserName}
        </Typography>
      </Flex>
      <Flex>
        <Typography __dangerDoNotUseSx={{ flex: 1 }} variant="body1" color="textSecondary">
          Inspection Date
        </Typography>
        <Typography __dangerDoNotUseSx={{ flex: 1 }} variant="body1">
          {order.inspectionDate?.isoString}
        </Typography>
      </Flex>
      <Flex>
        <Typography __dangerDoNotUseSx={{ flex: 1 }} variant="body1" color="textSecondary">
          Effective Date
        </Typography>
        <Typography __dangerDoNotUseSx={{ flex: 1 }} variant="body1">
          {effectiveDate?.isoString}
        </Typography>
      </Flex>
      <Flex>
        <Typography __dangerDoNotUseSx={{ flex: 1 }} variant="body1" color="textSecondary">
          License State
        </Typography>
        <Typography __dangerDoNotUseSx={{ flex: 1 }} variant="body1">
          {order.licenseState}
        </Typography>
      </Flex>
      <Flex>
        <Typography __dangerDoNotUseSx={{ flex: 1 }} variant="body1" color="textSecondary">
          License ID
        </Typography>
        <Typography __dangerDoNotUseSx={{ flex: 1 }} variant="body1">
          {order.licenseNumber}
        </Typography>
      </Flex>
      <Flex>
        <Typography __dangerDoNotUseSx={{ flex: 1 }} variant="body1" color="textSecondary">
          License Expiration
        </Typography>
        <Typography __dangerDoNotUseSx={{ flex: 1 }} variant="body1">
          {order.licenseExpiration?.isoString}
        </Typography>
      </Flex>
      <Flex>
        <Typography __dangerDoNotUseSx={{ flex: 1 }} variant="body1" color="textSecondary">
          License Type
        </Typography>
        <Typography __dangerDoNotUseSx={{ flex: 1 }} variant="body1">
          {order.licenseType}
        </Typography>
      </Flex>
    </Flex>
  );
};
